import Tour from "./js/generic/tour"
import { renderFilterSet } from "./js/filters"

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll("[data-section='filter-container']")
    .forEach(renderFilterSet)

  // Not currently lazy-loading because it's present on all filter pages
  const tourBtn = document.getElementById("tour-button")
  if (tourBtn) {
    Tour(tourBtn)
    window.setTimeout(() => tourBtn.classList.add("loaded"), 1000)
  }
})
